import React from 'react'
import PropTypes from 'prop-types'
import {Button, Flex, Image, SimpleGrid, Box, useMultiStyleConfig} from '@chakra-ui/react'
import {Link as RouteLink} from 'react-router-dom'
import useDamImage from '../../../custom-hooks/use-dam-image'
import {useIntl} from 'react-intl'
import SanitizedHtml from '../../html-sanitizer'
import {remCalc} from '../../../theme/_utils'

const KeyFeaturesCard = ({
    imageUrl,
    images,
    title,
    description,
    linkLabel,
    linkUrl,
    isSlider,
    isLinkAbsolute = false,
    aspectRatio = null,
}) => {
    const styles = useMultiStyleConfig('KeyFeatures', {
        variant: isSlider ? 'slider' : 'default',
    })

    const intl = useIntl()

    const damImage = useDamImage(images)

    const imageToUse = damImage.url || imageUrl

    const buttonProps = isLinkAbsolute
        ? {
              as: 'a',
              href: linkUrl,
              target: '_blank',
              rel: 'noopener noreferrer',
          }
        : {
              as: RouteLink,
              to: linkUrl,
          }
    return (
        <Flex {...styles.card}>
            <SimpleGrid {...styles.cardContent}>
                {imageToUse && (
                    <Image
                        width={!isSlider ? '100%' : 'inherit'}
                        height={!isSlider ? remCalc(230) : 'inherit'}
                        src={imageToUse}
                        aspectRatio={aspectRatio}
                        objectFit={'contain'}
                        alt={
                            title ||
                            intl.formatMessage({
                                id: 'key_features.image.alt.default',
                                defaultMessage: 'Key feature illustration',
                            })
                        }
                    />
                )}
                <SanitizedHtml as={Box} html={title} {...styles.cardTitle} />
                <SanitizedHtml as={Box} html={description} {...styles.cardDescription} />
            </SimpleGrid>
            {linkUrl && linkLabel && (
                <Button {...buttonProps} variant="primary" {...styles.cardButton}>
                    {linkLabel}
                </Button>
            )}
        </Flex>
    )
}

KeyFeaturesCard.propTypes = {
    isLinkAbsolute: PropTypes.bool,
    imageUrl: PropTypes.string,
    images: PropTypes.object,
    title: PropTypes.string,
    description: PropTypes.string,
    linkLabel: PropTypes.string,
    linkUrl: PropTypes.string,
    isSlider: PropTypes.bool,
    aspectRatio: PropTypes.string,
}

export default KeyFeaturesCard
